import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import ChangeLog from './change-log-model'
import {
  CreateChangeLogAsync,
  DeleteChangeLogAsync,
  LoadChangeLogsAsync,
} from './changeLog-thunk'
const initialState: changeLogSliceState = {
  changeLog: [],
  selected_changeLog: '',
  is_loading_changeLog: false,
  is_creating_changeLog: false,
  is_deleting_changeLog: false,
}
export interface changeLogSliceState {
  changeLog: ChangeLog[]
  selected_changeLog?: string
  is_loading_changeLog: boolean
  is_creating_changeLog: boolean
  is_deleting_changeLog: boolean
}
export const changeLogSlice = createSlice({
  name: 'changeLog',
  initialState,
  reducers: {
    setSelectedchangeLog: (state, action) => {
      state.selected_changeLog = action.payload
    },
    clearStatechangeLog: (state) => {
      state.changeLog = []
      state.is_loading_changeLog = false
      state.is_creating_changeLog = false
      state.is_deleting_changeLog = false
    },
    mergechangeLog: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_changeLog = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.changeLog = merge(state.changeLog, payload) as any
        }
      }
    },

    add_changeLog: (state, action) => {
      if (action.payload) {
        state.changeLog = [...state.changeLog, action.payload]
      }
    },
    set_changeLog: (state, action) => {
      let { key, value, id } = action.payload
      state.changeLog = state.changeLog.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadChangeLogsAsync.pending, (state) => {
      state.is_loading_changeLog = true
    })
    builder.addCase(LoadChangeLogsAsync.fulfilled, (state, action) => {
      state.is_loading_changeLog = false
      if (action.payload) {
        state.changeLog = action.payload
      }
    })
    builder.addCase(LoadChangeLogsAsync.rejected, (state) => {
      state.is_loading_changeLog = false
    })
    builder.addCase(CreateChangeLogAsync.pending, (state) => {
      state.is_creating_changeLog = true
    })
    builder.addCase(CreateChangeLogAsync.fulfilled, (state) => {
      state.is_creating_changeLog = false
    })
    builder.addCase(CreateChangeLogAsync.rejected, (state) => {
      state.is_creating_changeLog = false
    })
    builder.addCase(DeleteChangeLogAsync.pending, (state) => {
      state.is_deleting_changeLog = true
    })
    builder.addCase(DeleteChangeLogAsync.fulfilled, (state, action) => {
      state.is_deleting_changeLog = false
      if (state.changeLog) {
        state.changeLog = state.changeLog.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteChangeLogAsync.rejected, (state) => {
      state.is_deleting_changeLog = false
    })
  },
})

export const {
  clearStatechangeLog,
  setSelectedchangeLog,
  set_changeLog,
  mergechangeLog,
  add_changeLog,
} = changeLogSlice.actions

export const get_changeLog =
  (id?: string) =>
  (state: {
    changeLog: {
      changeLog: ChangeLog[]
    }
  }): ChangeLog | null => {
    let temp = state?.changeLog?.changeLog?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.changeLog?.changeLog[0] || null
  }
export const get_selected_changeLog = (state: {
  changeLog: changeLogSliceState
}): ChangeLog | null => {
  let id = state?.changeLog?.selected_changeLog
  let temp = state?.changeLog?.changeLog?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_changeLog = (state: {
  changeLog: {
    changeLog: ChangeLog[]
  }
}): ChangeLog[] => {
  let temp = state?.changeLog?.changeLog
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_changeLog_busy = (state: {
  changeLog: changeLogSliceState
}) => {
  return (
    state?.changeLog.is_deleting_changeLog ||
    state?.changeLog.is_loading_changeLog ||
    state?.changeLog.is_creating_changeLog
  )
}
export const is_deleting_changeLog_busy = (state: {
  changeLog: changeLogSliceState
}) => {
  return state?.changeLog.is_deleting_changeLog
}
export const is_loading_changeLog_busy = (state: {
  changeLog: changeLogSliceState
}) => {
  return state?.changeLog.is_loading_changeLog
}
export const is_creating_changeLog_busy = (state: {
  changeLog: changeLogSliceState
}) => {
  return state?.changeLog.is_creating_changeLog
}

export default changeLogSlice.reducer
